import generateBarcodeSheetDialogTemplate from './generateBarcodeSheetDialog.template.html';

/*****************************************************************************
 * Service: GenerateBarcodeSheetDialog
 *
 * This component allows a user to select specific item types that have a
 * barcode and generates the PDF to display the corresponding items that have
 * a barcode.
 *****************************************************************************/
/* @ngInject */ export function GenerateBarcodeSheetDialogService($uibModal, SERVER) {
  /** Dialog Controller. */
  var GenerateBarcodeSheetController = function ($scope) {
    /***************************************************************************
     * Constants
     ***************************************************************************/
    /*------------*/
    /* Item Types */
    /*------------*/
    var TYPES_PRODUCTS = [
      SERVER.BooksDBConstants.IT_PRODUCT,
      SERVER.BooksDBConstants.IT_GROUP,
      SERVER.BooksDBConstants.IT_MEMBERSHIP
    ];
    var TYPES_TRACKED = [
      SERVER.BooksDBConstants.IT_EQUIPMENT,
      SERVER.BooksDBConstants.IT_TEXTBOOKS
    ];

    /*---------*/
    /* Options */
    /*---------*/
    /** Product Item Type Options. */
    var OPTIONS_PRODUCTS = [
      { label: 'All Products', type: TYPES_PRODUCTS.join(',') },
      {
        label: 'Kits Only',
        type: SERVER.BooksDBConstants.IT_GROUP.toString()
      },
      {
        label: 'Inventory Products Only',
        type: SERVER.BooksDBConstants.IT_PRODUCT.toString(),
        inventory: true
      },
      {
        label: 'Non-Inventory Products Only',
        type: SERVER.BooksDBConstants.IT_PRODUCT.toString(),
        inventory: false
      }
    ];

    /** Tracked Item Type Options. */
    var OPTIONS_TRACKED = [
      { label: 'All Tracked Items', type: TYPES_TRACKED.join(',') },
      {
        label: 'Equipment Only',
        type: SERVER.BooksDBConstants.IT_EQUIPMENT.toString()
      },
      {
        label: 'Textbooks Only',
        type: SERVER.BooksDBConstants.IT_TEXTBOOKS.toString()
      }
    ];

    /***************************************************************************
     * Properties
     ***************************************************************************/
    /** Include Product Options. */
    var includeProducts = true;

    /** Include Tracked Options. */
    var includeTracked = true;

    /***************************************************************************
     * DataProvider
     ***************************************************************************/
    /** Barcode Options. */

    /***************************************************************************
     * activated */
    /**
     * Sets up the data provider and sets the selected index of the comboBox to
     * the select all option
     ***************************************************************************/
    function activated() {
      $scope.mDPOptions = [];

      if (includeTracked && includeProducts)
        $scope.mDPOptions = $scope.mDPOptions
          .concat({
            label: 'All Items',
            type: TYPES_PRODUCTS.concat(TYPES_TRACKED).join(',')
          })
          .concat(OPTIONS_TRACKED)
          .concat(OPTIONS_PRODUCTS);
      else
        $scope.mDPOptions = includeTracked
          ? OPTIONS_TRACKED
          : OPTIONS_PRODUCTS;

      $scope.selectedOption = $scope.mDPOptions[0];
    }

    /***************************************************************************
     * generateSheet */
    /**
     * Generates the report.
     ***************************************************************************/
    $scope.generateSheet = function () {
      var option = $scope.selectedOption;

      var pageURL = 'PrintItemBarcodesPDF.aspx?rt=PDF&its=' + option.type;
      var inventoryAttr = option.hasOwnProperty('inventory')
        ? '&inv=' + option.inventory
        : '';

      window.open(pageURL + inventoryAttr);
    };

    /*-------------*/
    /* Initialize. */
    /*-------------*/
    activated();
  };

  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog to provide a a dropdown with barcode options
   * to generate.
   *
   * @param  banks
   * @param  entities
   * @return            Promise to listen on
   *****************************************************************************/
  this.show = function () {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: GenerateBarcodeSheetController,
      size: 'md',
      template: generateBarcodeSheetDialogTemplate
    }).result;
  };
}
